import { render, staticRenderFns } from "./Speaker.vue?vue&type=template&id=71c19e98&scoped=true&"
import script from "./Speaker.vue?vue&type=script&lang=js&"
export * from "./Speaker.vue?vue&type=script&lang=js&"
import style0 from "./Speaker.vue?vue&type=style&index=0&id=71c19e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c19e98",
  null
  
)

export default component.exports